import { render, staticRenderFns } from "./ImportExpedientsDialogComponent.vue?vue&type=template&id=19cfba27&scoped=true"
import script from "./ImportExpedientsDialogComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./ImportExpedientsDialogComponent.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ImportExpedientsDialogComponent.vue?vue&type=style&index=0&id=19cfba27&lang=scss&scoped=true"
import style1 from "./ImportExpedientsDialogComponent.vue?vue&type=style&index=1&id=19cfba27&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cfba27",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19cfba27')) {
      api.createRecord('19cfba27', component.options)
    } else {
      api.reload('19cfba27', component.options)
    }
    module.hot.accept("./ImportExpedientsDialogComponent.vue?vue&type=template&id=19cfba27&scoped=true", function () {
      api.rerender('19cfba27', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Expedients/components/ImportExpedientsDialog/ImportExpedientsDialogComponent.vue"
export default component.exports